import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import InputGeneric from "../../../components/Inputs/InputGeneric";
import { ArrowSmUpIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";
import banner from "../../../assets/Banners/NetUnoTelefonia2.jpg";
import bannerNew from "../../../assets/banner nuevos/Banner_telefonia_new.jpg";
import { colors } from "../../../propsType/Colors";
import { TabNavegation } from "../../../propsType/TabNavegation";
import { SortDescendingIcon, SortAscendingIcon } from "@heroicons/react/solid";
import ConsumoController from "../../../controllers/ConsumoController";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import moment from "moment";
import { useForm } from "../../../Hooks/UseForm";
import {
  formDetalleTelefonia
} from "../../../propsType/Services";
import {
  ArrowLeftIcon,
  ArrowDownIcon,
  ArrowNarrowUpIcon,
  magnifyingglass
} from "@heroicons/react/solid";
import { validateDetalleTelefonia } from "../../../validations/formValidations";
import descargaContrato from "../../../assets/svg/descargar_contrato.svg";
import SoftphoneCard from "../../../components/Softphone/SoftphoneCard";
import { buildContratoId } from "../../../helpers/contratoFormatter";

function DetailsTelefonia() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const { detalleTelefonia } = ConsumoController();
  const [deatils, setDeatils] = useState(null);
  const [{ user }] = UseContextApp();
  const [listaLlamada, setListaLlamada] = useState([]);
  const { tabsHogarDetails, tabsEmpresaDetails } = TabNavegation(pathName)
  const [tabs, setTabs] = useState(user?.datos?.tipoCliente === 'Hogar' ? tabsHogarDetails : tabsEmpresaDetails || [''])
  const [loading, setLoading] = useState(false);
  const [isConsumo, setIsConsumo] = useState("");
  const { form, errors, setForm, handleChange, handleSubmit, handleBlur } = useForm(formDetalleTelefonia, validateDetalleTelefonia,);

  const getDTelefonia = async (item) => {
    setIsConsumo("true");
    setListaLlamada([]);
    let result = null;
    result = handleSubmit();
    if (result === "ok") {
      setLoading(true);
      let newObjet =
      {
        idCustomerPO: deatils?.idCustomerTlf,
        fechaDesde: form.dateIni,
        fechaHasta: form.dateFin,
      };
      const res = await detalleTelefonia(newObjet);
      if (res) {
        if (res.codigo === "0") {
          setListaLlamada(res.detalleLlamada);
          setLoading(false);
        }
        else { setLoading(false);setListaLlamada([]);}
      }
    }
  };

  const imprimir = () => {
    /* let printContents = document.getElementById('print-mount').innerHTML;
     let originalContents = document.body.innerHTML;
     document.body.innerHTML = printContents;
     window.print();
     document.body.innerHTML = originalContents;*/

    window.print();
  };

  const handleRedirectDescargarContrato = (e) => {
    e.preventDefault();
  
    // Obtener la URL actual y agregar el parámetro `send_message`
    const currentPath = location.pathname;
    const newUrl = `${currentPath}?send_message=Copia%20de%20contrato`;
  
    // Navegar a la misma página con el parámetro añadido en la URL
    navigate(newUrl, { state: { ...location.state }, replace: true });
  
    // Recargar el componente sin perder `location.state`
    setTimeout(() => {
      navigate(0);
    }, 100);
  };

  const getDetalleTelefonia = async (item) => {
    setIsConsumo("true");
    setLoading(true);
    let mes = "";
    let anoMes = "";
    let iniDate = "";
    let finDate = "";
    const CURRENT_MONTH = (new Date().getMonth() + 1);
    const CURRENT_YEARS = new Date().getFullYear();
    const CURRENT_DAYS = new Date().getDate();
    let dia = (CURRENT_DAYS.toString().length === 1 ? '0' + CURRENT_DAYS.toString() : CURRENT_DAYS);
    let month = (CURRENT_MONTH.toString().length === 1 ? '0' + CURRENT_MONTH.toString() : CURRENT_MONTH);
    finDate = (CURRENT_YEARS + '-' + month + '-' + dia);
    iniDate = (CURRENT_YEARS + '-' + month + '-' + "01");
    let newObjet =
    {
      idCustomerPO: deatils?.idCustomerTlf,
      fechaDesde: iniDate,
      fechaHasta: finDate,
    };
    const res = await detalleTelefonia(newObjet);
    if (res) {
      if (res.codigo === "0") {
        setListaLlamada(res.detalleLlamada);
        setLoading(false);

      }
      else { setLoading(false); }
    }

  };


  const stats = [
    {
      name: "Número de Cuenta",
      stat: deatils?.cuenta,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Número de Contrato",
      stat: deatils?.contrato,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Estatus",
      stat: "  ",
      previousStat: "",
      change: deatils?.status,
      changeType: "increase",
    },
  ];

  const statsCard = [
    {
      id: 1,
      name: "Minutos Disponibles Llamadas Nacionales",
      status: true,
      stat: (deatils?.consumoTelefonia.length > 0 ? deatils?.consumoTelefonia[1] : "Ha ocurrido un error consultando el consumo"),
      icon: SortAscendingIcon,
      change: "",
      changeType: "increase",
    },
    {
      id: 2,
      name: "Minutos Disponibles Llamadas Internacionales",
      status: true,
      stat: (deatils?.consumoTelefonia.length > 0 ? deatils?.consumoTelefonia[0] : "Ha ocurrido un error consultando el consumo"),
      icon: SortAscendingIcon,
      change: "",
      changeType: "increase",
    },
  ];



  useEffect(() => {
    setDeatils(location?.state?.data);

  }, [location]);

  function handleChangeRoute(e) {

    let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
        navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Televisión":
        navigate("/cuenta/servicio-de-television");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      default:
        break;
    }
  }
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  return (
    <>
      {loading ? (
        <>
          <div className="w-full h-screen flex justify-center items-center ">
            <Spinner title={"Espere..."} />
          </div>
        </>
      ) : (
        <>
          <div className=" relative bg-[#f3f4f6]">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
              <div className="flex lg:w-full gap-5 p-[20px] lg:p-2 overflow-auto flex-col">
                {/*   Recibe la navegacion y actualiza que te indica en que ruta estas */}
                <BreadCrumbsGeneric locations={pathName} />
                <div>
                  <div>
                    <div className="sm:hidden">
                      <label htmlFor="tabs" className="sr-only">
                        Select a tab
                      </label>
                      <select
                        id="tabs"
                        name="tabs"
                        onChange={handleChangeRoute}
                        className="block w-full h-11 p-[10px] shadow focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                        defaultValue={tabs.find((tab) => tab.current)?.name}
                      >
                        {tabs.map((tab) => (
                          <option key={tab?.name}>{tab?.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="hidden sm:block">
                      <nav
                        className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                        aria-label="Tabs"
                      >
                        {tabs.map((tab, tabIdx) => (
                          <Link
                            key={tab?.name}
                            to={tab.href}
                            className={classNames(
                              tab.current
                                ? "text-gray-900"
                                : "text-gray-500 hover:text-gray-700",
                              tabIdx === 0 ? "rounded-l-lg" : "",
                              tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                              "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                            )}
                            aria-current={tab.current ? "page" : undefined}
                          >
                            <span>{tab?.name}</span>
                            <span
                              aria-hidden="true"
                              className={classNames(
                                tab.current
                                  ? `bg-[${colors.lightBlue}]`
                                  : "bg-transparent",
                                "absolute inset-x-0 bottom-0 h-0.5"
                              )}
                            />
                          </Link>
                        ))}
                      </nav>
                    </div>
                  </div>
                </div>
                <div>
                  <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                    {stats.map((item, index) => (
                      <div
                        key={item?.name}
                        className="px-4 flex justify-between items-center py-5 sm:p-6"
                      >
                        <div>
                          <dt className={` ${index === 2 && 'mb-[10px]'} text-base  flex justify-between items-center font-normal text-gray-900 `}>
                            {item?.name === "Correo" ? (
                              <>
                                <div> {item?.name}</div>
                              </>
                            ) : (
                              <>{item?.name}</>
                            )}
                          </dt>
                          <dd className="mt-1 flex justify-between items-center md:block lg:flex">
                            <div
                              className={`flex items-baseline text-2xl font-semibold text-[${colors.lightBlue}] `}
                            >
                              {item.stat}
                              <span className="ml-2 text-sm font-medium text-gray-500">
                                {" "}
                                {item.previousStat}
                              </span>
                            </div>
                            <div
                              className={classNames(
                                item.changeType === "increase" &&
                                "bg-green-100 text-green-800",
                                "inline-flex items-baseline px-2.5 py-0.5 rounded-full  text-sm font-medium md:mt-2 lg:mt-0"
                              )}
                            >
                              {item.changeType === "increase" && (
                                <ArrowSmUpIcon
                                  className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                                  aria-hidden="true"
                                />
                              )}
                              <span className="sr-only">
                                {item.changeType === "increase"
                                  ? "Increased"
                                  : "Decreased"}
                                by
                              </span>
                              {item.change}
                            </div>
                          </dd>
                        </div>
                      </div>
                    ))}
                  </dl>
                </div>
                <div>
                  <main>
                    <div className=" max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-5">
                      <div className="space-y-6 lg:col-start-1 lg:col-span-3">
                        <section aria-labelledby="applicant-information-title">
                          <div className="bg-white shadow h-full sm:rounded-lg">
                            <div className="px-4 py-5 sm:px-6">
                              <h2
                                id="applicant-information-title"
                                className="text-lg leading-6 font-medium text-gray-900"
                              >
                                Detalles de Servicio
                              </h2>
                              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                                Servicios Telefonía
                              </p>
                            </div>
                            <div className="border-t border-gray-200 px-4 h-full py-5 sm:px-6 ">
                              <dl className="grid grid-cols-1 gap-x-2 gap-y-4 md:grid-cols-3">
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Paquete
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.paquete}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Tecnología
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.tecnologia}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Titular
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {user?.datos?.nombreApellido}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Número de teléfono
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.nroCustomerTlf}{" "}
                                  </dd>
                                </div>
                                <div className="sm:col-span-1">
                                  <dt className="text-sm font-medium text-gray-500">
                                    Ciudad
                                  </dt>
                                  <dd className="mt-1 text-sm text-gray-900">
                                    {deatils?.ciudad}{" "}
                                  </dd>
                                </div>
                                <div className="border-t border-gray-200 pt-6 md:border-t-0 md:pt-0 md:pl-6 md:col-start-3 md:row-start-1 md:row-span-3">
                                  <SoftphoneCard
                                    contrato={buildContratoId({
                                      contrato: deatils?.contrato,
                                      cCiudad: deatils?.cCiudad,
                                      codOperadora: deatils?.codOperadora,
                                    })}
                                    cuenta={deatils?.cuenta}
                                    token={user?.token}
                                  />
                                </div>
                              </dl>

                            </div>
                            <div
                              onClick={(e) => handleRedirectDescargarContrato(e)}
                              className={`flex justify-center items-center bg-[${colors.lightBlue}] text-md text-white hover:bg-[${colors.darkBlue}] cursor-pointer  duration-300 easy hover:text-white text-sm font-medium  text-center  sm:rounded-b-lg  px-4 py-4`}
                            >
                              <img className="w-[20px] mr-[4px]" src={descargaContrato} alt="" />
                              Descargar contrato
                            </div>
                          
                              
                            <div className={`block text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center sm:rounded-b-lg`}>
                            </div>
                            
                          </div>
                        </section>
                      </div>
                      <section
                        aria-labelledby="timeline-title"
                        className="lg:col-span-2 relative"
                      >
                        <div className="bg-white  shadow sm:rounded-lg h-full ">
                          <div className="px-4 py-5 sm:px-6">
                            <h2
                              id="applicant-information-title"
                              className="text-lg leading-6 font-medium text-gray-900"
                            >
                              Consumo de la Cuenta
                            </h2>
                            <p className="mt-1 max-w-2xl text-sm text-gray-500">
                              Servicios Telefonía
                            </p>
                          </div>
                          <dl className=" flex flex-col border-t pb-[70px] lg:pb-0 p-5 gap-4 border-gray-200 ">
                            {statsCard.map((item) => (
                              <div
                                key={item.id}
                                className="relative bg-white pl-[20px] pt-5 shadow rounded-lg overflow-hidden"
                              >
                                <dt>
                                  <div
                                    className={`absolute bg-[${colors.lightBlue}] rounded-md p-3`}
                                  >
                                    <item.icon
                                      className="h-6 w-6 text-white"
                                      aria-hidden="true"
                                    />
                                  </div>
                                  <p className="ml-16 text-sm font-medium text-gray-500 truncate">
                                    {item.name}
                                  </p>
                                </dt>
                                <dd className="ml-16 pb-6 flex items-baseline ">
                                  <p className="text-sm font-semibold text-gray-900">
                                    {item.stat}
                                  </p>
                                </dd>
                              </div>
                            ))}
                          </dl>
                          <div className="absolute bottom-0 w-full">
                            <div
                              onClick={() => getDetalleTelefonia()}
                              className={`block bg-[${colors.lightBlue}] text-md text-white hover:bg-[${colors.darkBlue}] cursor-pointer  duration-300 easy hover:text-white text-sm font-medium  text-center px-4 py-4  sm:rounded-b-lg`}
                            >
                              Ver Detalle del Consumo
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </main>
                </div>
                <div style={isConsumo === "true" ? { display: '' } : { display: 'none' }}>
                  <div className="!m-0  sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] shadow-lg  mt-5 ">
                    <div className=" py-5 sm:px-6 border-b  border-gray-200 ">
                      <h2
                        id="applicant-information-title"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >Consumo del mes
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm text-gray-500">El detalle de consumo solo contiene información del mes actual.<br></br>
                      </p>
                      <div className=" py-5 sm:px-6 border-b  border-gray-200 ">
                          <div className="grid !mt-1  grid-cols-7">
                            <div className="col-span-2">
                              <InputGeneric
                                type={"date"}
                                textTopTips={"Fecha inicio de consulta"}
                                iconTop={true}
                                maxProps={moment().format("YYYY-MM-DD")}
                                min="2024-01-01"
                                title={"Desde"}
                                value={form.dateIni}
                                onChange={handleChange}
                                handleBlur={handleBlur}
                                name={"dateIni"}
                                errorText={errors.dateIni}

                              />

                            </div>
                            <div className="col-span-2">
                              <InputGeneric
                                type={"date"}
                                textTopTips={"Fecha fin de consulta"}
                                iconTop={true}
                                maxProps={moment().format("YYYY-MM-DD")}
                                min="2024-01-01"
                                title={"Hasta"}
                                value={form.dateFin}
                                onChange={handleChange}
                                handleBlur={handleBlur}
                                name={"dateFin"}
                                errorText={errors.dateFin}

                              />
                            </div>
                            <div className="col-span-1 content-end">
                              <button type="submit" className="text-start content-center flex justify-start py-2 px-4" onClick={() => getDTelefonia()}>🔍</button>

                            </div>
                          </div>
                        </div>
                    </div>
                    {listaLlamada?.length > 0 ? (
                      <>
                        <div id="print-mount" className="pl-5 flex flex-col gap-4 mx-auto">
                          <div className="bg-white shadow overflow-hidden sm:rounded-md">
                            <ul role="list" className="divide-y divide-gray-200">
                              <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-6 sm:px-6 border-b border-gray-200">
                                <div
                                  className={`font-medium text-center flex justify-center pl-9 gap-2  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  <div>Fecha</div>
                                </div>
                                <div
                                  className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  Remitente
                                </div>
                                <div
                                  className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  Destino
                                </div>
                                <div
                                  className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  Ubicación
                                </div>
                                <div
                                  className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  Tipo de Llamada
                                </div>
                                <div
                                  className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                                >
                                  Duración
                                </div>
                              </div>
                              {listaLlamada?.map((data, index) => (
                                <li key={index}>
                                  <div className="px-4 py-4 grid gap-4 lg:grid-cols-6 sm:px-6 group-hover:bg-gray-50">
                                    <div className="mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Fecha
                                      </div>
                                      <div className="flex">{data.Hora_Inicio.split('T')[0] + " " + data.Hora_Inicio.split('T')[1]}</div>
                                    </div>
                                    <div
                                      className={`mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 sm:ml-6`}
                                    >
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Remitente
                                      </div>
                                      {data.Remitente}
                                    </div>
                                    <div
                                      className={`mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 sm:ml-6`}
                                    >
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Destino
                                      </div>
                                      {data.Destinatario}
                                    </div>
                                    <div
                                      className={`mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 sm:ml-6`}
                                    >
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Ubicación
                                      </div>
                                      {data.Ubicación}
                                    </div>
                                    <div
                                      className={`text-sm text-start flex-col justify-center flex items-center font-medium text-gray-500  truncate`}
                                    >
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Tipo de Llamada
                                      </div>
                                      {data.TipoDeLlamada}
                                    </div>
                                    <div>
                                      <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                        <div className="font-medium text-[14px] md:hidden block  ">
                                          Duración
                                        </div>
                                        <div className="flex">{data.Duración}</div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold">
                          No posees detalle de telefonía en estos momentos
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <img className="w-full h-full rounded-t-lg" src={bannerNew} alt="" /> 
              </div>
            </div>

           
            

          </div>
        </>
      )
      }
    </>
  );

}

export default DetailsTelefonia;
